import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'

class DropdownSelect extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      dropdownOpen: false,
      searchText: ''
    }

    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.selectItem = this.selectItem.bind(this)
    this.renderDropdownItems = this.renderDropdownItems.bind(this)
  }

  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    })
  }

  selectItem(item) {
    this.toggleDropdown()
    this.setState({
      searchText: ''
    })
    this.props.onChange(item[this.props.itemSelector], this.props.attribute)
  }

  renderDropdownItems() {
    const allItems = this.props.items.filter((item) => item[this.props.itemAttribute].toLowerCase().includes(this.state.searchText))
    if(allItems.length === 0) {
      return(
        <div className="dropdownItem" style={{color: 'black'}}>
          <h3>No results</h3>
        </div>
      )
    }
    return allItems.map((item, i)  => {
      return(
        <div key={i} onClick={() => this.selectItem(item)} className="dropdownItem">
          <h3>{item[this.props.itemAttribute]}</h3>
        </div>
      )
    })

  }

  renderSearchBar() {
    return(
      <div style={{display: 'flex', padding: 10}}>
        <FontAwesomeIcon
          icon={faSearch}
          style={{color: '#979797', fontSize: 16, marginRight: 10}}
        />
        <input
          className="searchInput"
          value={this.state.searchText}
          onChange={(event) => this.setState({searchText: event.target.value})}
          placeholder={`Search ${this.props.label}`}
        />
      </div>
    )
  }

  render() {
      return(
        <div
          className="clickable"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}>
            <p className="label_standard">{this.props.label}</p>
            <div
              onClick={() => this.toggleDropdown()}
              className="input_standard"
              style={{display: 'flex', alignItems: 'center'}}>
              <div style={{width: '95%'}}>
              <p>{this.props.value}</p>
              </div>
              <FontAwesomeIcon
                icon={this.state.dropdownOpen ? faChevronUp : faChevronDown}
                className="lightBlue"
                style={{fontSize: 18}}
              />
            </div>
            {this.state.dropdownOpen &&
              <div style={{backgroundColor: 'white'}} className="dropDownContainer">
                {this.renderSearchBar()}
                <div style={{height: 300, overflowY: 'scroll'}}>
                  {this.renderDropdownItems()}
                </div>
              </div>}
        </div>
      )
  }
}

export default DropdownSelect;
